import {
  CatalogSearchResultItem,
  ColumnDefinition,
  FieldRenderer,
} from '../types';
import { DevHubDynamicIcon, DevHubLink } from '@devxdiscover/devhub-ui';
import { NavLink } from 'react-router-dom';
import { Column } from 'primereact/column';

const apiDefinitionLinkTemplate = (row: CatalogSearchResultItem) => {
  return (
    <DevHubLink
      component={NavLink}
      to={`/catalog/default/api/${row?.id}/definition`}
    >
      <DevHubDynamicIcon iconName="Category" />
    </DevHubLink>
  );
};

/**
 * Renders the API definition link field
 * @param col The column definition
 * @param index The index of the column
 */
export const apiDefinitionRenderer: FieldRenderer = (
  col: ColumnDefinition,
  index: number,
) => {
  return (
    <Column
      key={index}
      field={col.field}
      header={col.header}
      style={{ width: col.width }}
      body={apiDefinitionLinkTemplate}
    />
  );
};
